module.exports = __webpack_public_path__ + "img/title.573670b8.png";